
import { Component, Vue } from "vue-property-decorator";
import AddServicepoint from "@/pages/servicepoint/ServicepointAddPage.vue";
import ServicepointsTable from "@/components/servicepoint/ServicepointsTable.vue";
import AddMassiveServicePointModal from "@/components/servicepoint/AddMassiveServicePointModal.vue";
import { Getter } from "vuex-class";
import { IUserDetailData } from "@/entities";

enum CashAddServicepointTypes {
  MANUAL = "MANUAL",
  MASSIVE = "MASSIVE",
}
@Component({
  name: "servicepoints-page",
  components: { AddServicepoint, ServicepointsTable, AddMassiveServicePointModal },
})
export default class ServicepointsPage extends Vue {
  @Getter("getLoggedUser") loggedUser!: IUserDetailData;
  addServicepointTypes = Object.values(CashAddServicepointTypes);
  openAddMassiveServicePointModal = false;
  isReadyToAddServicePointModal = false;
  constructor() {
    super();
  }

  async goToAddServicepoint(addServicepointType: CashAddServicepointTypes): Promise<void> {
    if (addServicepointType === CashAddServicepointTypes.MANUAL) {
      await this.$router.push({
        name: "add-servicepoint",
      });
    } else if (addServicepointType === CashAddServicepointTypes.MASSIVE) {
      this.openAddMassiveServicePointModal = true;
      this.$nextTick(() => {
        this.$bvModal.show("add-massive-service-point-modal");
      });
    }
  }

  close(): void {
    this.$bvModal.hide("add-massive-service-point-modal");
    this.openAddMassiveServicePointModal = false;
  }

  importSuccess(): void {
    this.makeToast("success", this.$t("label.add.massive.servicepoints.success").toString());
    this.close();
  }

  makeToast(variant: string, message: string): void {
    this.$bvToast.toast(message, {
      autoHideDelay: 4000,
      variant,
      toaster: "b-toaster-bottom-center",
      noCloseButton: true,
    });
  }

  get enableAddMassiveServicePoint(): boolean {
    const isAdmin = this.loggedUser?.admin || false;
    return isAdmin && this.isReadyToAddServicePointModal;
  }
}
